import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import AddCityModal from '../../CommonComps/Modals/AddCityModal';

const AddCityAction = ({
  hasCreatePermission,
}: {
  hasCreatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // rendering add city action component here
  return (
    <div>
      <AcademiaButton
        title={
          !hasCreatePermission ? 'You do not have permissions!' : undefined
        }
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
        isDisabled={!hasCreatePermission}
      >
        Add City
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <AddCityModal handleModalClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </div>
  );
};

export default AddCityAction;
